/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * NEXMAIL (Internal)
 * Internal API consumed by the nexmail dashboard.
 * OpenAPI spec version: 0.0.1
 */

/**
 * User role in this organization
 */
export type OrganizationResponseDtoRole =
  (typeof OrganizationResponseDtoRole)[keyof typeof OrganizationResponseDtoRole];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrganizationResponseDtoRole = {
  owner: 'owner',
  editor: 'editor',
} as const;
